import dayjs from 'dayjs';

export const getFormattedDate = (date: string): string => {
  const dateObject = dayjs(date);
  const now = dayjs();

  const currentYear = now.year();

  const day = dateObject.format('DD');
  const month = dateObject.format('MMM');
  const time = dateObject.format('HH:mm');
  const year = dateObject.year();

  return `${day} ${month} ${currentYear === year ? '' : year} ${time}`;
};
